/**
 * Keeps the translation bundles in the wording of the signed-in center
 * (centerTerms.js): learning as written, sport → trainees / training sessions
 * / coaches, clinics → clients. Follows the auth store, so logging in,
 * switching center or logging out re-words every screen at once.
 */
import i18n from './config';
import useAuthStore from '../store/authStore';
import { createCenterTerms, termSetFor } from './centerTerms';

export const centerTerms = createCenterTerms(i18n);

const setFor = (s) => (s.token ? termSetFor(s.centerType, s.learningSubType) : null);

centerTerms.set(setFor(useAuthStore.getState()));
useAuthStore.subscribe((s) => centerTerms.set(setFor(s)));
